import { render, staticRenderFns } from "./HolidayBuilder.vue?vue&type=template&id=1947d06a&scoped=true"
import script from "./HolidayBuilder.vue?vue&type=script&lang=js"
export * from "./HolidayBuilder.vue?vue&type=script&lang=js"
import style0 from "./HolidayBuilder.vue?vue&type=style&index=0&id=1947d06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947d06a",
  null
  
)

export default component.exports